<dx-popup
  [(visible)]="visible"
  [width]="width"
  [height]="height"
  [showTitle]="false"
  [showCloseButton]="true"
  [dragEnabled]="false"
  (onHidden)="close()"
>
  <div *dxTemplate="let d of 'content'" >
    <div class="h-full flex flex-col">
      <div class="mb-4">
        <div *ngIf="title" class="text-xl font-semibold">
          {{ title }}
        </div>

        <div *ngIf="subtitle" class="text-sm text-gray-500 mt-1">
          {{ subtitle }}
        </div>
      </div>

      <div class="flex-1 min-h-0">
        <div class="flex h-full gap-4">
          <div class="gs-popup-form">
            <ng-content select="[gs-popup-form]"></ng-content>
          </div>

          <div class="flex-1 min-w-0">
            <ng-content select="[gs-popup-tabs]"></ng-content>
          </div>
        </div>
      </div>

      <div class="mt-4 flex justify-end gap-2">
        <dx-button
          *ngIf="showSaveButton"
          [text]="'common.save' | translate | ucfirst"
          type="default"
          [disabled]="saving"
          (onClick)="onSave()"
        ></dx-button>

        <dx-button
          [text]="(showSaveButton ? 'common.cancel' : 'common.close') | translate | ucfirst"
          (onClick)="close()"
        ></dx-button>
      </div>
    </div>

  </div>
</dx-popup>
